.groupedIconBackground {
  width: 16px;
  height: 16px;
  margin: 0 var(--spacingXs);
  border-radius: 50%;
  background-color: var(--paletteBlue0);

  &.dark {
    border: 1px solid var(--paletteBlue2);
  }
}
